module.exports = __webpack_public_path__ + "static/media/azurelook.83772d48.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/azurelook.png
// module id = 846
// module chunks = 7